//Comentario necesario para codificación en UTF-8, ver Inc6743

(function() {
	angular.module('pphhApp')
		.controller("wmPhasesController", ["$scope", "$mdDialog", "$window",
			"CommonCatalogService", "wmPhasesService", "pphhEnv", WMPhasesController])
		.controller("showScopeController", ["$scope", "phase", ShowScopeController]);

	function WMPhasesController($scope, $mdDialog, $window, commonCatalogService, wmPhasesService,
		pphhEnv) {
		var rbdFilter = [];

		$scope.isLoading = false;

		$scope.filterResults = [];

		$scope.module = "dma";

		$scope.init = init;
		$scope.doFilter = doFilter;
		$scope.showScope = showScope;
		$scope.downloadScope = downloadScope;
		$scope.changePhaseLevel = changePhaseLevel;
		$scope.filterPhaseLevel = filterPhaseLevel;

		function init() {
			commonCatalogService.getWaterModules()
				.then(function(response) {
					$scope.waterModules = response.data;
				});
		}

		function doFilter(tableState, ctrl) {
			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return;
			}

			$scope.isLoading = true;

			wmPhasesService.getPhases($scope.module)
				.then(
					function(response) {
						rbdFilter = response.data.rbdFilter;
						$scope.filterResults = response.data.phases;
						$scope.isLoading = false;
					},
					function() {
						$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error get",
								ok: UIMessages.dialog.confirm.cerrar,
								multiple: true
							}));

						$scope.isLoading = false;
					}
				);
		}

		function showScope(phase) {
			$mdDialog.show(
				$mdDialog.alert({
					title: UIMessages.dialog.confirm.title,
					ok: UIMessages.dialog.confirm.cerrar,
					clickOutsideToClose: true,
					template:
						'<md-dialog>'
						+ '<md-dialog-content>'
						+ '<div class="md-dialog-content">'
						+ '<div layout="column">'
						+ '  <md-input-container flex>'
						+ '    <input ng-model="searchText" />'
						+ '    <md-icon class="material-icons md-24">search</md-icon>'
						+ '  </md-input-container>'
						+ '  <md-list flex>'
						+ '    <md-list-item class="md-2-line" ng-repeat="tableConfig in phase.tableConfigurations | filter: searchText">'
						+ '      <div class="md-list-item-text" layout="column">'
						+ '        <h3>{{tableConfig.tableName}}</h3>'
						+ '        <p ng-repeat="columnName in tableConfig.columnNames" style="padding-left: 1em">'
						+ '        {{columnName}}'
						+ '        </p>'
						+ '      </div>'
						+ '    </md-list-item>'
						+ '  </md-list>'
						+ '</div>'
						+ '</div>'
						+ '</md-dialog-content>'
						+ '</md-dialog>',
					locals: {
						phase: phase
					},
					controller: "showScopeController"
				}));
		}

		function downloadScope(phase) {
			$window.location.href = pphhEnv.global.contextPath + "/wmphases/" + $scope.module + "/phase/" + phase.id + "/scope";
		}

		function changePhaseLevel(phase, level) {
			$scope.isLoading = true;
			wmPhasesService.changePhaseLevel($scope.module, phase.id, level.euDhCod, level.level)
				.then(
					function() {
						doFilter();
					},
					function() {
						$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error changing level",
								ok: UIMessages.dialog.confirm.cerrar,
								multiple: true
							}));

						$scope.isLoading = false;
					}
				);
		}

		function filterPhaseLevel(phaseLevel) {
			return rbdFilter.length === 0 || rbdFilter.indexOf(phaseLevel.euDhCod) >= 0;
		}
	}

	function ShowScopeController($scope, phase) {
		$scope.phase = phase;
	}

})();